module.exports = __webpack_public_path__ + "img/calendario.17be6251.svg";